<template>
  <h1>Debug</h1>
</template>
<script lang="ts" setup>

</script>
